import { render, staticRenderFns } from "./Badge2.vue?vue&type=template&id=a6255a74&scoped=true"
import script from "./Badge2.vue?vue&type=script&lang=js"
export * from "./Badge2.vue?vue&type=script&lang=js"
import style0 from "./Badge2.vue?vue&type=style&index=0&id=a6255a74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6255a74",
  null
  
)

export default component.exports